<template>
  <div class="LoginForm d-flex flex-column h-100">
    <h1 class="text-center mb-4 pb-2">Verificatie van bevestiging</h1>
    <div style="min-height: 60px">
      <Feedback :feedback="feedback" />
    </div>

    <div class="d-flex justify-content-center mt-5">
      <router-link 
        class="text-muted"
        :to="{ name: 'login' }">
        Terug naar login
      </router-link>
    </div>
  </div>
</template>

<script>
import { confirm, getUser } from 'service/auth'
import { mapMutations } from 'vuex'

import Feedback from 'atom/Feedback'

import timeout from 'mixin/timeout'

export default {
  name: 'ConfirmEmailForm',
  components: {
    Feedback
  },
  mixins: [ timeout ],
  data() {
    return {
      feedback: {},
      token: ''
    }
  },
  created() {
    this.feedback = {
      variant: 'info', 
      message: 'Bezig het verifieren van de bevestiging'
    }
    
    if (this.$route.hash) {
      // Get the token, after #recovery_token=
      this.token = this.$route.hash.split("=").pop()
      
      // Clear hash from route
      this.$router.push({ name: this.$route.name })
    }

    confirm({ token: this.token })
      .then(() => {
        this.feedback = {
          variant: 'success', 
          message: 'De verificatie is geslaagd. U wordt automatisch ingelogd.'
        }
        this.setUser({ authenticatedUser: getUser() })
        this.setTimeout(() => {
          this.$router.push({ name: 'home' })
        }, 2000)
      })
      .catch(() => {
        this.feedback = {
          variant: 'danger', 
          message: 'De verificatie is mislukt.'
        }
      })
  },
  methods: {
    ...mapMutations('user', [
      'setUser'
    ]),
  }
}
</script>
